import * as React from 'react';
import PropTypes from 'prop-types';

const SvgSportsSnowshoeNormalXsmall = React.forwardRef(
  ({ color, size, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M14.56 1.61A3.507 3.507 0 008.5 4.23l.52 8.13a2.967 2.967 0 001.58 2.45l1.4.76 1.4-.75a2.989 2.989 0 001.58-2.45l.52-8.13a3.45 3.45 0 00-.94-2.63zM9.59 5.5h.92v2h-.8zm1.91 8.66l-.43-.23a1.964 1.964 0 01-1.05-1.63l-.24-3.8h.73v1.51a1.474 1.474 0 00.99 1.4zm0-10.57a1.43 1.43 0 00-.9.91H9.52l-.02-.33a2.464 2.464 0 01.67-1.88 2.427 2.427 0 011.33-.74zm.99 6.42a.49.49 0 01-.98 0V4.99a.49.49 0 11.98 0zm1.49 2.29a1.988 1.988 0 01-1.05 1.64l-.43.23v-2.76a1.474 1.474 0 00.99-1.4V8.5h.73zm.31-4.8h-.8v-2h.92zm.19-3H13.4a1.43 1.43 0 00-.9-.91V1.55c.511.098.978.357 1.33.74a2.463 2.463 0 01.67 1.88zM.5 4.23l.52 8.13a2.967 2.967 0 001.58 2.45l1.4.76 1.4-.75a2.988 2.988 0 001.58-2.45l.52-8.13A3.508 3.508 0 004 .5a3.458 3.458 0 00-2.56 1.11A3.426 3.426 0 00.5 4.23zM1.59 5.5h.92v2h-.8zm1.91 8.66l-.43-.23a1.964 1.964 0 01-1.05-1.63l-.24-3.8h.73v1.51a1.474 1.474 0 00.99 1.4zM6.29 7.5h-.8v-2h.92zM4.5 1.55c.511.098.978.357 1.33.74a2.464 2.464 0 01.67 1.88l-.02.33H5.4a1.43 1.43 0 00-.9-.91zm0 9.86a1.474 1.474 0 00.99-1.4V8.5h.73l-.24 3.8a1.988 1.988 0 01-1.05 1.64l-.43.23zM3.51 5.5v-.51a.49.49 0 01.98 0v5.02a.49.49 0 11-.98 0zM2.17 2.29a2.427 2.427 0 011.33-.74v2.04a1.43 1.43 0 00-.9.91H1.52l-.02-.33a2.464 2.464 0 01.67-1.88z"
        fill=""
      />
    </svg>
  )
);
SvgSportsSnowshoeNormalXsmall.defaultProps = {
  color: 'currentColor',
  size: 16,
  title: undefined,
  titleId: undefined
};
SvgSportsSnowshoeNormalXsmall.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  title: PropTypes.string,
  titleId: PropTypes.string
};
export default SvgSportsSnowshoeNormalXsmall;
